import { render } from "./MarkdownViewer.vue?vue&type=template&id=22fc4376"
import script from "./MarkdownViewer.vue?vue&type=script&lang=js"
export * from "./MarkdownViewer.vue?vue&type=script&lang=js"

import "./MarkdownViewer.vue?vue&type=style&index=0&id=22fc4376&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__